/**
 * Core / Plugin: Helpers
 * -----------------------------------------------------------------------------
 * Vue plugin to extend Vue instance with global helpers.
 * - Create separate files for each and add in alphabetical order.
 *
 */
import blockClass from '~/core/helpers/block-class';
import classHelper from '~/core/helpers/class';
import formatDate from '~/core/helpers/format-date';
import formatImageUrl from '~/core/helpers/format-image-url';
import formatMoney from '~/core/helpers/format-money';
import string from '~/core/helpers/string';
import timing from '~/core/helpers/timing';
import variable from '~/core/helpers/variable';

/**
 * Expose install method.
 * - See imported files for supported arguments and what's returned.
 */
export default {
  install: (app) => {
    app.config.globalProperties.$blockClass = blockClass;
    app.config.globalProperties.$class = classHelper;
    app.config.globalProperties.$formatDate = formatDate;
    app.config.globalProperties.$formatImageUrl = formatImageUrl;
    app.config.globalProperties.$formatMoney = formatMoney;
    app.config.globalProperties.$string = string;
    app.config.globalProperties.$timing = timing;
    app.config.globalProperties.$variable = variable;
  },
};
